"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.back = exports.changeLocale = exports.navigate = exports.INTL_LANGUAGE_KEY = void 0;
const gatsby_link_1 = require("gatsby-link");
require("./types");
exports.INTL_LANGUAGE_KEY = `decentraland-gatsby-intl`;
function navigate(to, options) {
    var _a;
    if (typeof window === 'undefined') {
        return;
    }
    const intl = window.___decentralandGatsbyIntl;
    if (!intl) {
        return;
    }
    const locale = (_a = options === null || options === void 0 ? void 0 : options.locale) !== null && _a !== void 0 ? _a : intl.locale;
    const link = locale === intl.defaultLocale ? to : `/${locale}${to}`;
    localStorage.setItem(exports.INTL_LANGUAGE_KEY, locale);
    (0, gatsby_link_1.navigate)(link, options);
}
exports.navigate = navigate;
function changeLocale(locale) {
    if (typeof window === 'undefined') {
        return;
    }
    const intl = window.___decentralandGatsbyIntl; // || {}
    if (!intl || locale === intl.locale) {
        return;
    }
    const prefix = (0, gatsby_link_1.withPrefix)(intl.locale === intl.defaultLocale ? `/` : `/${intl.locale}`);
    const pathname = window.location.pathname.slice(0, prefix.length);
    localStorage.setItem(exports.INTL_LANGUAGE_KEY, locale);
    (0, gatsby_link_1.navigate)([
        locale === intl.defaultLocale ? `` : `/${locale}`,
        pathname,
        window.location.search,
        window.location.hash,
    ].join(''));
}
exports.changeLocale = changeLocale;
function back(fallback = '/') {
    if (window.___decentralandNavigationUpdates) {
        window.history.back();
    }
    else {
        navigate(fallback);
    }
}
exports.back = back;
